import {
  TypedUseSelectorHook,
  useSelector as useSelectorRedux,
} from 'react-redux';
import { OwlStore } from '@owl-frontend/redux';
import claimOverviewSlice from '../components/ClaimOverview/data/logic';
import claimOverviewShellSlice from '../components/ClaimOverviewShell/data/logic';
import activitiesSlice from './activities/logic';
import agentChatThreadsSlice from './agentChatThreads/logic';
import artifactsSlice from './artifacts/logic';
import eventsSlice from './events/logic';
import feedbackSlice from './feedback/logic';
import filesSlice from './files/logic';
import localizationSlice from './localization/logic';
import notificationsSlice from './notifications/logic';
import policyClaimsSlice from './policyClaims/logic';
import runsSlice from './runs/logic';
import schemasSlice from './schemas/logic';
import searchSlice from './search/logic';
import sessionSlice from './session/logic';
import storeOptions from './storeOptions';
import tasksSlice from './tasks/logic';
import userEventsSlice from './userEvents/logic';
import wikiSlice from './wiki/logic';
import wsSlice from './ws/logic';

// MARK: Claim Overview
const store = new OwlStore([], {}, storeOptions);
store.addSlice(activitiesSlice);
store.addSlice(agentChatThreadsSlice);
store.addSlice(artifactsSlice);
store.addSlice(claimOverviewSlice);
store.addSlice(eventsSlice);
store.addSlice(userEventsSlice);
store.addSlice(feedbackSlice);
store.addSlice(filesSlice);
store.addSlice(localizationSlice);
store.addSlice(notificationsSlice);
store.addSlice(policyClaimsSlice);
store.addSlice(runsSlice);
store.addSlice(schemasSlice);
store.addSlice(searchSlice);
store.addSlice(sessionSlice);
store.addSlice(tasksSlice);
store.addSlice(wikiSlice);
store.addSlice(wsSlice);

// MARK: Claim Overview Shell
store.addSlice(claimOverviewShellSlice);

if (process.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept('./activities/logic', () =>
    store.addSlice(activitiesSlice, true)
  );
  module.hot.accept('./agentChatThreads/logic', () =>
    store.addSlice(agentChatThreadsSlice, true)
  );
  module.hot.accept('./artifacts/logic', () =>
    store.addSlice(artifactsSlice, true)
  );
  module.hot.accept('./schemas/logic', () =>
    store.addSlice(schemasSlice, true)
  );
  module.hot.accept('./events/logic', () => store.addSlice(eventsSlice, true));
  module.hot.accept('../components/ClaimOverview/data/logic', () =>
    store.addSlice(claimOverviewSlice, true)
  );
  module.hot.accept('./userEvents/logic', () =>
    store.addSlice(userEventsSlice, true)
  );
  module.hot.accept('./feedback/logic', () =>
    store.addSlice(feedbackSlice, true)
  );
  module.hot.accept('./files/logic', () => store.addSlice(filesSlice, true));
  module.hot.accept('./localization/logic', () =>
    store.addSlice(localizationSlice, true)
  );
  module.hot.accept('./notifications/logic', () =>
    store.addSlice(notificationsSlice, true)
  );
  module.hot.accept('./policyClaims/logic', () =>
    store.addSlice(policyClaimsSlice, true)
  );
  module.hot.accept('./runs/logic', () => store.addSlice(runsSlice, true));
  module.hot.accept('./search/logic', () => store.addSlice(searchSlice, true));
  module.hot.accept('./session/logic', () =>
    store.addSlice(sessionSlice, true)
  );
  module.hot.accept('./tasks/logic', () => store.addSlice(tasksSlice, true));
  module.hot.accept('./wiki/logic', () => store.addSlice(wikiSlice, true));
  module.hot.accept('./ws/logic', () => store.addSlice(wsSlice, true));

  // MARK: Claim Overview Shell
  module.hot.accept('../components/ClaimOverviewShell/data/logic', () =>
    store.addSlice(claimOverviewShellSlice, true)
  );
}
export interface StoreState {
  [activitiesSlice.name]: (typeof activitiesSlice)['initialState'];
  [agentChatThreadsSlice.name]: (typeof agentChatThreadsSlice)['initialState'];
  [artifactsSlice.name]: (typeof artifactsSlice)['initialState'];
  [claimOverviewSlice.name]: (typeof claimOverviewSlice)['initialState'];
  [eventsSlice.name]: (typeof eventsSlice)['initialState'];
  [userEventsSlice.name]: (typeof userEventsSlice)['initialState'];
  [feedbackSlice.name]: (typeof feedbackSlice)['initialState'];
  [filesSlice.name]: (typeof filesSlice)['initialState'];
  [localizationSlice.name]: (typeof localizationSlice)['initialState'];
  [notificationsSlice.name]: (typeof notificationsSlice)['initialState'];
  [policyClaimsSlice.name]: (typeof policyClaimsSlice)['initialState'];
  [runsSlice.name]: (typeof runsSlice)['initialState'];
  [schemasSlice.name]: (typeof schemasSlice)['initialState'];
  [searchSlice.name]: (typeof searchSlice)['initialState'];
  [sessionSlice.name]: (typeof sessionSlice)['initialState'];
  [tasksSlice.name]: (typeof tasksSlice)['initialState'];
  [wikiSlice.name]: (typeof wikiSlice)['initialState'];
  [wsSlice.name]: (typeof wsSlice)['initialState'];

  // MARK: Claim Overview Shell
  [claimOverviewShellSlice.name]: (typeof claimOverviewShellSlice)['initialState'];
}
export default store as OwlStore<any> as OwlStore<StoreState>;
export const useSelector: TypedUseSelectorHook<StoreState> = useSelectorRedux;
